import 'css-chunk:../search/modal/index.module.scss';export default {
  "modal": "_modal_1durj_1",
  "shortcuts": "_shortcuts_1durj_6"
};